/* eslint-disable no-nested-ternary */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
import Table from 'components/Table'
import Avatar from 'components/Avatar'
import ActionMenu from 'components/ActionMenu'
import { defaultDirection, toggleDirection } from 'utils/sort'
import constants from 'constants'
import { hasAccess } from 'utils/hasAccess'

const styles = Object.assign(
  {},
  require('./PersonalInfoList.scss'),
  { table: require('components/Table/Table.scss') },
  { columns: require('./columns.scss') },
)

class PersonalInfoList extends Component {
  static propTypes = {
    // onSelectedPartner: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
    history: PropTypes.object,
    onChangeFilteredPersonalInfos: PropTypes.func,
    openPartnerHierarchyForm: PropTypes.func.isRequired,
    openPartnerPlanStatusForm: PropTypes.func.isRequired,
    personalinfos: PropTypes.instanceOf(Array),
    setSelectedPartner: PropTypes.func,
    unfilteredPersonalInfos: PropTypes.instanceOf(Array),
  }
  static defaultProps = {
    history: null,
    unfilteredPersonalInfos: null,
    onChangeFilteredPersonalInfos: [],
    setSelectedPartner: null,
    personalinfos: [],
  }
  constructor(props) {
    super(props)
    this.data = this.props.unfilteredPersonalInfos
    this.state = {
      sort: {
        type: 'name',
        direction: 'asc',
      },
    }
  }

  componentWillReceiveProps(nextProps) {
    const { personalinfos } = this.props
    this.data = personalinfos
    if (nextProps.personalinfos !== this.props.personalinfos) {
      this.data = nextProps.personalinfos
    }
  }

  sortBy = (type) => {
    return () => {
      const sortRules = this.state.sort
      const hasTypeChanged = type !== sortRules.type
      const direction = hasTypeChanged
        ? defaultDirection()
        : toggleDirection(sortRules.direction)

      /* setState works in an asynchronous way.
        That means after calling setState the this.state variable is not immediately changed.
        so if you want to perform an action immediately after setting state on a state variable and then return a result, a callback will be useful */
      this.setState({ sort: { type, direction } }, () => {
        /* TODO: please put your sort logic here */
        const sortedData = [].concat(this.props.unfilteredPersonalInfos)
          .sort((a, b) => {
            if (this.state.sort.type === 'name') {
              return (a.name > b.name) ? 1 : -1
            } else if (this.state.sort.type === 'id') {
              // return (a.id - b.id) ? 1 : -1
              // return (parseInt(a.id) - parseInt(b.id)) ? 1 : -1
              // return ((parseInt(a.id) > parseInt(b.id)) - (parseInt(a.id) < parseInt(b.id)))
              return (Number(a.id) > Number(b.id) ? 1 : Number(a.id) < Number(b.id) ? -1 : 0)
            } else if (this.state.sort.type === 'status') {
              return (a.status > b.status) ? 1 : -1
            } else if (this.state.sort.type === 'location') {
              return (a.location > b.location) ? 1 : -1
            } else if (this.state.sort.type === 'code') {
              return (a.code > b.code) ? 1 : -1
            }
            return null
          })

        if (this.state.sort.direction === 'desc') {
          sortedData.reverse()
        }

        this.data = sortedData // needs immediate effect on the list
        this.props.onChangeFilteredPersonalInfos(this.data)
      })
    }
  }

  sortStyles = (name, { type, direction } = {}, sortable = true) => {
    return {
      [styles.columns[name]]: true,
      [styles.table.sortable]: sortable,
      [styles.table.unSortable]: !sortable,
      [styles.table.activeSort]: name === type,
      [styles.table.ascending]: direction === 'asc',
      [styles.table.descending]: direction === 'desc',
    }
  }

  handleSelectedPartner(personalInfo, label, type) {
    const partnerSideBar = [{
      employee_id: personalInfo.id,
      status: personalInfo.status,
      Counselling_Partner_Name: personalInfo.Counselling_Partner_Name,
      Business_Leader_Name: personalInfo.Business_Leader_Name,
      Market_Leader_Name: personalInfo.Market_Leader_Name,
      Client_Industry_Leader_Name: personalInfo.Client_Industry_Leader_Name,
      Service_Area_Leader_Name: personalInfo.Service_Area_Leader_Name,
      Counselling_Partner_Employee_Id: personalInfo.Counselling_Partner_Employee_Id,
      Business_Leader_Employee_Id: personalInfo.Business_Leader_Employee_Id,
      Market_Leader_Employee_Id: personalInfo.Market_Leader_Employee_Id,
      Client_Industry_Leader_Employee_Id: personalInfo.Client_Industry_Leader_Employee_Id,
      Service_Area_Leader_Employee_Id: personalInfo.Service_Area_Leader_Employee_Id,
    }]
    const selectedPartner = {
      EmployeeId: personalInfo.id,
      Name: personalInfo.name,
      Email: personalInfo.email,
      userPrincipalName: personalInfo.email,
      partnerSideBar,
    }
    this.props.setSelectedPartner(selectedPartner)

    /* if (sessionStorage.getItem('AdminCentreFilterSelection')) {
      const filterSelection = JSON.parse(sessionStorage.getItem('AdminCentreFilterSelection'))
    } */  

    if (String(label) === 'Plan status' && String(type) === constants.ADMINCENTRE_TYPE.MODAL) {
      setTimeout(() => { this.props.openPartnerPlanStatusForm() }, 800)
    } else if (String(label) === 'Partner hierarchy' && String(type) === constants.ADMINCENTRE_TYPE.MODAL) {
      setTimeout(() => { this.props.openPartnerHierarchyForm() }, 800)
    }
  }

  renderCols = () => {
    const sortRules = this.state.sort
    return (
      <tr>
        <th className={classnames(styles.columns.name, this.sortStyles('name', sortRules))} colSpan={2} onClick={this.sortBy('name')}>Name</th>
        <th className={classnames(styles.columns.id, this.sortStyles('id', sortRules))} onClick={this.sortBy('id')}>ID</th>
        <th className={classnames(styles.columns.status, this.sortStyles('status', sortRules))} onClick={this.sortBy('status')}>Status</th>
        <th className={classnames(styles.columns.code, this.sortStyles('code', sortRules))} onClick={this.sortBy('code')}>Code</th>
        <th className={classnames(styles.columns.location, this.sortStyles('location', sortRules))} onClick={this.sortBy('location')}>Location</th>
        <th />
      </tr>
    )
  }

  renderData = () => {
    const sortedData = this.data
    // apply permission to the action menu
    const actionMenu = constants.ADMINCENTRE.ACTIONMENU.map(menu => (hasAccess(this.props.currentUser, menu.permission, this.props.history, '', false) ? {
      key: menu.key,
      label: menu.label,
      type: menu.type,
      path: menu.path,
    } : null)).filter(a => a)
    return (
      sortedData.length > 0 ? sortedData.map(personalinfo => (
        <tr className={styles.base} key={personalinfo.id}>
          <td className={classnames(styles.table.narrowRight, styles.flushRight)}>
            <Avatar className={styles.avatar} size="small" title={personalinfo.initials} />
          </td>
          <td className={classnames(styles.nameCell, styles.table.narrowLeft)}>
            {personalinfo.name}
            <br /><span className={styles.emaildata}>{personalinfo.email}</span>
          </td>
          <td className={styles.table.narrowRight}>
            {personalinfo.id}
          </td>
          <td className={styles.table.narrowRight}>
            {personalinfo.status}
          </td>
          <td className={styles.table.narrowRight}>
            {personalinfo.code}
          </td>
          <td className={styles.table.narrowRight}>
            {personalinfo.location}
          </td>
          <td className={styles.table.narrowRight}>
            <div className={styles.adminSideMenu}>
              <ActionMenu
                handleOnClick={(label, type) => this.handleSelectedPartner(personalinfo, label, type)}
                menu={actionMenu}
              />
            </div>
          </td>
        </tr>
      )) : <tr><td className={styles.emptyresult} colSpan={6}>No matching records found</td></tr>
    )
  }

  render() {
    return (
      <Table>
        <thead>
          {this.renderCols()}
        </thead>
        <tbody>
          {this.renderData()}
        </tbody>
      </Table>
    )
  }
}

export default PersonalInfoList



// WEBPACK FOOTER //
// ./src/views/AdminCentre/components/PersonalInfoList.js